import React from 'react'
import { useAppSelector } from '../../../../store/hooks/StoreHooks';
import useCollapseFacade from '../../../../facade/collapse.Facade';
import Accordion from '../../../common/accordion';
import LABELS from '../../../../constants/labels/schematics.labels';

const SetDepthSummary = () => {
    const { setDepthSummaryCollapse } = useAppSelector(
        (state) => state?.collapse
    );
    const { schematicData } = useAppSelector(state => state?.calculations);

    const { updateSetDepthSummaryCollapse } = useCollapseFacade();

    const handleCollapseChange = (key: boolean) => {
        updateSetDepthSummaryCollapse(key);
    };

    return (
        <Accordion
            title={LABELS?.setDepthSummary}
            isOpen={setDepthSummaryCollapse}
            onToggle={() => handleCollapseChange(!setDepthSummaryCollapse)}
            content={
                <div className="flex justify-center items-center p-4 gap-4 w-full">
                    <div className="flex flex-col justify-between items-center border-[1px] border-darkcolor-400 rounded-[8px] w-1/2">
                        <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                            <label className="text-neutral-25 text-[14px] font-normal">
                                {LABELS?.eoTubing}
                            </label>
                            <label className="text-neutral-25">{schematicData?.eoTubing}
                            </label>
                        </div>
                        <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                            <label className="text-neutral-25">{LABELS?.intakeSetDepth}</label>
                            <label className="text-neutral-25">{schematicData?.intakeSetDepth}</label>
                        </div>
                        <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                            <label className="text-neutral-25">{LABELS?.sensorDepth}</label>
                            <label className="text-neutral-25">{schematicData?.sensorDepth}
                            </label>
                        </div>
                        <div className="flex justify-between items-center py-[9px] px-[24px] w-full">
                            <label className="text-neutral-25">{LABELS?.setDepth}</label>
                            <label className="text-neutral-25">{schematicData?.setDepth}
                            </label>
                        </div>
                    </div>
                    <div className="flex flex-col justify-between items-center border-[1px] border-darkcolor-400 rounded-[8px] w-1/2">
                        <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                            <label className="text-neutral-25">{LABELS?.mleLengthForSplice}</label>
                            <label className="text-neutral-25">{schematicData?.mleLength ?? 0} {LABELS?.ft}</label>
                        </div>
                        <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                            <label className="text-neutral-25">{LABELS?.totalEspLength}</label>
                            <label className="text-neutral-25">{schematicData?.totalEspLength ?? 0} {LABELS?.ft}</label>
                        </div>
                        <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                            <label className="text-neutral-25">{LABELS?.espDesander}</label>
                            <label className="text-neutral-25">{schematicData?.espTailPipeDescender ?? 0} {LABELS?.ft}</label>
                        </div>
                        <div className="flex justify-between items-center py-[9px] px-[24px] w-full">
                            <label className="text-neutral-25">{LABELS?.totalDownholeEquipmentWeight}</label>
                            <label className="text-neutral-25">{schematicData?.downholeEquipmentWeight} {LABELS?.lb}</label>
                        </div>
                    </div>
                </div>
            }
        />
    );
}

export default SetDepthSummary